import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Moment } from 'moment';
import map from 'lodash/map';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import messages from 'src/pages/ProjectDetailsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

export interface backupJobParamsType {
  uuid: string;
  status: string;
  quantity: string;
  wageBonus: string;
  shifts: Array<{ startsAt: string | Moment; endsAt: string | Moment }>;
}

const updateBackupJob = async ({ uuid, ...backupJob }: backupJobParamsType) => {
  const params = {
    job: {
      total_vacancies: backupJob.quantity,
      wage_bonus: backupJob.wageBonus,
      status_code: backupJob.status,
      job_dates: map(backupJob.shifts, (shift) => ({
        start_date_time: shift.startsAt,
        end_date_time: shift.endsAt,
      })),
    },
  };

  const { data } = await putRequest<RequestSimplifiedData>(
    API.PUT.updateBackupJob(uuid),
    params,
  );

  return data;
};

export const useUpdateBackupJob = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateBackupJob,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.backupJobSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.BACKUP_JOB] });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.BACKUP_JOB_SHFT_OPTIONS],
      });
    },
    onError: handleError,
  });
};
